import React from "react";

const QuizProgressBar = ({ currentStep, totalSteps }) => {
  const pct = totalSteps > 0 ? ((currentStep + 1) / totalSteps) * 100 : 0;

  return (
    <div className="tbb-quiz__progress">
      <div
        className="tbb-quiz__progress-fill"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
};

export default QuizProgressBar;
